module.exports = __webpack_public_path__ + "static/media/contemplar_te_6.5392fb23.jpg";